import { render } from "./ViewAddPaymentTotalField.vue?vue&type=template&id=21a3af3b"
import script from "./ViewAddPaymentTotalField.vue?vue&type=script&lang=js"
export * from "./ViewAddPaymentTotalField.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__